<template>
  <div name="demo-upload-file">
    <dropzone id="vueDropzone" :url="url" :useFontAwesome="true" v-on:vdropzone-success="showSuccess" acceptedFileTypes="application/pdf,.doc,.docx,.xlsx,.xls" :showRemoveLink="false">
        <input type="hidden" name="token" value="xxx">
    </dropzone>
    {{url}}
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'
import env from 'src/../env.js'

export default {
  name: 'demo-upload-file',
  data () {
    return {
      url: window.localStorage.getItem(env.site + '_baseURL') + 'api/uploader/uploadFile'
    }
  },
  props: [ 'type' ],
  methods: {
    showSuccess (file) {
      console.log('A file was successfully uploaded')
    }
  },
  components: {
    Dropzone
  }
}
</script>


// WEBPACK FOOTER //
// demoUploadFile.vue?328503ea